
import auth from '../tools/storage.js';
// import auth from '../tools/storage.js';

export default {



  getElement(item, index) {
    
    let arrColors = ['#7fc8f8', '#FFBBD0','#FFCC01' , '#66A672'];
    let indexColor = index%arrColors.length;
    let firstLetter = 'F';
    if(item.name && item.name.length > 1)
      firstLetter = item.name.charAt(0);
  return ` <button type="button" btFilmID = ${item.id} class="btn cloud"  name="otherFilm" data-toggle="tooltip" title="${item.name}" style="background-color: ${arrColors[indexColor]} !important;">${firstLetter}</button>`;
  },

  ifnull (someData) {
    return (someData)? someData : '';
  },

  drawDataInDiv(dataToDisplay , currentFilmID) {

    // return '';
    let htmlBody = '';
    if(dataToDisplay && dataToDisplay.length > 1) {
      htmlBody = '<div class="cloudOtherFilms">';
      dataToDisplay.forEach((item, index) => {
        // console.log(item);
        if(item.id != currentFilmID)
          htmlBody += this.getElement(item, index);
      });
      htmlBody += '</div>';
    }
    return htmlBody;
  },

};
